var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadCurved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.06066,
    y: 12.3137,
    width: 14.5,
    height: 14.5,
    rx: 3.25,
    transform: "rotate(-45 2.06066 12.3137)",
    stroke: "#2B323B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4902 8.69866C15.5624 8.35915 15.2752 8.05115 14.9315 8.09951L11.7548 8.54642C11.3542 8.60277 11.1829 9.0867 11.4588 9.38254L12.2084 10.1865C12.2008 10.1942 12.1932 10.202 12.1854 10.21C11.9794 10.4219 11.7055 10.7287 11.4309 11.1119C10.8901 11.8664 10.2998 12.9823 10.2998 14.2899V16.3995C10.2998 16.7861 10.6132 17.0995 10.9998 17.0995C11.3864 17.0995 11.6998 16.7861 11.6998 16.3995V14.2899C11.6998 13.3974 12.1095 12.5682 12.5688 11.9275C12.7832 11.6282 12.9984 11.3843 13.1644 11.2116L13.9681 12.0734C14.244 12.3693 14.7387 12.2321 14.8228 11.8365L15.4902 8.69866Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadCurved);
export default __webpack_public_path__ + "static/media/road-curved.f067ab3ba72e6d0685bd470cf16809b1.svg";
export { ForwardRef as ReactComponent };